export enum ProviderAuth {
  GOOGLE = 'GOOGLE'
}
